import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Svg from 'rp-react-svg-icon';
import RpTable from 'rp-react-table';
import browserHistory from '../../../index';
import columns from './columns';
import getSortFn from './getSortFn';
import SpecialRow from './SpecialRow';
import Slider from './Slider';
import { isRunner } from './helper';
import mergeWithMR from './mergeWithMR';
import { myRatingsType, formType } from '../dataPropTypes';

const sliderConfig = {
    nonRunnerSwitcher: { stateProp: 'isNRShown', title: 'Non-Runner Info' },
    delimiterLineSwitcher: { stateProp: 'isBreakShown', title: 'Breaks (50+ days)' },
    myRatingSwitcher: { title: 'My Rating' },
};

class FormTable extends Component {
    constructor(props) {
        super(props);


        if (localStorage.getItem('myRatingSwitcher')) {
            this.myRatingToggle(true);
        } else {
            this.myRatingToggle();
        }

        if (localStorage.getItem('delimiterLineSwitcher') === null) {
            localStorage.setItem('delimiterLineSwitcher', true);
        }

        this.state = {
            isNRShown: localStorage.getItem('nonRunnerSwitcher') === 'true',
            isBreakShown: localStorage.getItem('delimiterLineSwitcher') === 'true',
            sortBy: '',
            indexDefault: 0,
        };

        this.getColumnsConfig = columns.bind(null, this.updateSortBy);
        this.handleSlider = this.handleSlider.bind(this);
        this.handleMyRatingSlider = this.handleMyRatingSlider.bind(this);
    }

    onSortIndexChange = (index) => {
        this.setState({
            indexDefault: index,
        });
    }

    handleSlider(key) {
        if (localStorage.getItem(key) === 'true') {
            this.setState({ [sliderConfig[key].stateProp]: false });
            localStorage.setItem(key, false);
        } else {
            this.setState({ [sliderConfig[key].stateProp]: true });
            localStorage.setItem(key, true);
        }
    }

    handleMyRatingSlider() {
        const { params: { mr: myRatings } } = this.props;
        const key = 'myRatingSwitcher';

        if (!myRatings.isShown) {
            localStorage.setItem(key, true);
            this.myRatingToggle(true);
        } else {
            localStorage.removeItem(key);
            this.myRatingToggle();
        }
    }

    myRatingToggle = (show) => {
        const { params: { id, name, mr: myRatings } } = this.props;
        const myRatingState = show ? 'show' : 'hide';
        const configUrl = {
            show: `horse/${id}/${name}/form/my-ratings`,
            hide: `horse/${id}/${name}/form`,
        };
        browserHistory.replace(configUrl[myRatingState]);
        if (myRatings[myRatingState]) { myRatings[myRatingState](); }
    }

    updateSortBy = (sortBy) => {
        if (sortBy !== this.state.sortBy) {
            this.setState({
                sortBy,
            });
        }
    }


    render() {
        const { data: { loading, form, myRatings },
            selectedFilter,
            hasSpecial,
            params,
        } = this.props;
        const { mr: { isShown: isMRShown } } = params;
        const { isNRShown, isBreakShown, sortBy, indexDefault } = this.state;
        let tableData = isNRShown ? form : form.filter(isRunner);
        tableData = isMRShown ? mergeWithMR(tableData, myRatings) : tableData;

        return (
            <section>
                <div className="hp-formTable__header">
                    <h2 className="hp-formTable__title">
                  Form {selectedFilter && `- ${selectedFilter}`}
                    </h2>
                    <div className="hp-formTable__sliderContainer">
                        {
                            Object.keys(sliderConfig).map(key => (
                                <Slider
                                    key={key}
                                    handleSlider={() => (
                                        (key === 'myRatingSwitcher') ?
                                            this.handleMyRatingSlider() :
                                            this.handleSlider(key))
                                    }
                                    sliderState={
                                        key === 'myRatingSwitcher' ?
                                            isMRShown :
                                            this.state[sliderConfig[key].stateProp]
                                    }
                                    title={sliderConfig[key].title}
                                    id={key}
                                    disabled={
                                        key === 'delimiterLineSwitcher' &&
                                        (selectedFilter || indexDefault !== 0)
                                    }
                                />
                            ))
                        }
                    </div>
                    {loading && (
                        <Svg
                            iconName="spinner"
                            size="Large"
                            className="ui-animation_spinnerAnimation"
                        />
                    )}
                </div>
                <RpTable
                    className={classNames(
                        'hp-formTable',
                        isMRShown && 'hp-formTable__my-ratings',
                        isNRShown && 'nonRunnerSliderSwitcher',
                        !isBreakShown && 'hp-formTable__delimiterHide'
                    )}
                    data={tableData}
                    columns={this.getColumnsConfig(sortBy)}
                    noDataText="No form for this horse"
                    sortable
                    initialSortIdx={indexDefault}
                    filter={getSortFn(selectedFilter)}
                    specialRow={hasSpecial ? SpecialRow : undefined}
                    onSortUpdate={this.onSortIndexChange}
                />
            </section>
        );
    }
}

FormTable.propTypes = {
    data: PropTypes.shape({
        form: PropTypes.arrayOf(formType),
        myRating: myRatingsType,
        loading: PropTypes.bool,
    }),
    params: PropTypes.shape({ mr: PropTypes.shape({ isShown: PropTypes.bool }) }),
    selectedFilter: PropTypes.string,
    hasSpecial: PropTypes.bool.isRequired,
};

export default FormTable;



// WEBPACK FOOTER //
// ./src/js/horse/form/formTable/FormTable.jsx